import SettingsPageContent from "./SettingsPageContent";

export default SettingsPageContent;
